namespace Matrix.Navigation {
    export interface FullTextSearchResult {
        EntityType?: string;
        EntityId?: any;
        DisplayText?: string;
    }
}
